import { render, staticRenderFns } from "./BlackPageUpload.vue?vue&type=template&id=1d715058&scoped=true&"
import script from "./BlackPageUpload.vue?vue&type=script&lang=js&"
export * from "./BlackPageUpload.vue?vue&type=script&lang=js&"
import style0 from "./BlackPageUpload.vue?vue&type=style&index=0&id=1d715058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d715058",
  null
  
)

export default component.exports